import { Description } from '@headlessui/react';
import clsx from 'clsx';

export function Hint({
	invalid,
	children,
}: Readonly<{ invalid?: boolean; children: React.ReactNode }>) {
	const className = clsx('text-xs', {
		'text-red': invalid,
	});

	return <Description className={className}>{children}</Description>;
}
